import { RankingBadge } from '../../rankings/components/RankingBadge'

interface Award {
  name: string
  snapshotId?: string
  url?: string
}

interface ShopAwardsBadgeProps {
  awards: Award[] | null
}

export function ShopAwardsBadge({ awards }: ShopAwardsBadgeProps) {
  if (!awards || awards.length === 0) return null

  return (
    <div className="flex overflow-x-auto md:flex-wrap gap-3 px-6 md:px-12 -mt-4 mb-6 relative z-10 no-scrollbar snap-x snap-mandatory">
      {awards.map((awardRaw, idx) => {
        const award = typeof awardRaw === 'string' ? { name: awardRaw } : awardRaw
        if (!award || !award.name) return null
        
        return <div key={idx} className="flex-none snap-start"><RankingBadge award={award} size="lg" /></div>
      })}
    </div>
  )
}
